import {Avatar, Card, CardActionArea, CardHeader, Divider, Grid, Typography, useTheme} from "@mui/material";
import SvgIconSteam from "../util/SvgIconSteam";
import SvgIconRuStore from "../util/SvgIconRuStore";
import SvgIconGooglePlay from "../util/SvgIconGooglePlay";
import SvgIconXiaomiGetApps from "../util/SvgIconXiaomiGetApps";
import SvgIconYandexMusic from "../util/SvgIconYandexMusic";
import SvgIconVKMusic from "../util/SvgIconVKMusic";
import SvgIconZvuk from "../util/SvgIconZvuk";
import SvgIconMTSMusic from "../util/SvgIconMTSMusic";
import SvgIconSpotify from "../util/SvgIconSpotify";
import SvgIconAppleMusic from "../util/SvgIconAppleMusic";
import React from "react";
import {useLocale} from "../locale/Locale";
import SvgIconPlayground from "../util/SvgIconPlayground";
import SvgIconStopGame from "../util/SvgIconStopGame";
import SvgIconTheDailyTelefrag from "../util/SvgIconTheDailyTelefrag";
import SvgIconSFEROOM from "../util/SvgIconSFEROOM";
import SvgIconBandLink from "../util/SvgIconBandLink";

function AppOther() {

    const {localeText} = useLocale()

    const xs = 12
    const sm = 6
    const md = 4
    
    return (
        <>
            <Typography variant="h2" align="center">{localeText('otherTitle')}</Typography>
            <Typography align="center" mb={2}>{localeText('otherDescription')}</Typography>
            <Grid container spacing={2}>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://store.steampowered.com/developer/isaev-space"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconSteam/>
                                    </Avatar>
                                }
                                title="Steam"
                                subheader="ISAEV SPACE"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://www.rustore.ru/catalog/developer/b6b9d111"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconRuStore/>
                                    </Avatar>
                                }
                                title="RuStore"
                                subheader="ISAEV SPACE"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://play.google.com/store/apps/dev?id=6648438553280805647"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconGooglePlay/>
                                    </Avatar>
                                }
                                title="Google Play"
                                subheader="ISAEV SPACE"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://global.app.mi.com/developer?id=1083266"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconXiaomiGetApps/>
                                    </Avatar>
                                }
                                title="Xiaomi GetApps"
                                subheader="ISAEV"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://music.yandex.ru/artist/22224668"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconYandexMusic/>
                                    </Avatar>
                                }
                                title={localeText('yandexMusic')}
                                subheader="ISAEV SPACE"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://vk.com/artist/isaevspace"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconVKMusic/>
                                    </Avatar>
                                }
                                title={localeText('vkMusic')}
                                subheader="ISAEV SPACE"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://zvuk.com/artist/212921545"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconZvuk/>
                                    </Avatar>
                                }
                                title={localeText('zvuk')}
                                subheader="ISAEV SPACE"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://music.mts.ru/artist/22224668"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconMTSMusic/>
                                    </Avatar>
                                }
                                title={localeText('mtsMusic')}
                                subheader="ISAEV SPACE"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://open.spotify.com/artist/1l5mHN7QScSLqH2gCDmc3K"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconSpotify/>
                                    </Avatar>
                                }
                                title="Spotify"
                                subheader="ISAEV SPACE"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://music.apple.com/us/artist/isaev-space/1746917536"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconAppleMusic/>
                                    </Avatar>
                                }
                                title="Apple Music"
                                subheader="ISAEV SPACE"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://lk.sferoom.space/artists/70042"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconSFEROOM/>
                                    </Avatar>
                                }
                                title="SFEROOM"
                                subheader="ISAEV SPACE"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://band.link/scanner?search=22224668&type=artist_id&service=yandex_music"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconBandLink/>
                                    </Avatar>
                                }
                                title="BandLink Сканер"
                                subheader="ISAEV SPACE"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://dailytelefrag.ru/user/75"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconTheDailyTelefrag/>
                                    </Avatar>
                                }
                                title="The Daily Telefrag"
                                subheader="user/75"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://www.playground.ru/vitta_lucis"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconPlayground/>
                                    </Avatar>
                                }
                                title="PlayGround"
                                subheader="vitta_lucis"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://stopgame.ru/game/vitta_lucis"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconStopGame/>
                                    </Avatar>
                                }
                                title="StopGame"
                                subheader="vitta_lucis"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
            <Divider sx={{my: 4}}/>
        </>
    )

}

export default AppOther
